module.exports = __webpack_public_path__ + "static/img/live_banner.2d79ca24.jpg";